module.exports = __webpack_public_path__ + "default.b9ea33db.png";